import { takeLatest, put, call, delay } from 'redux-saga/effects';
import * as type from '../../redux/types/trans';
import Api from '../../services/trans/trans';

let allApi = new Api();

async function fetchUser(data) {
    let res = await allApi.common(data);
    return res;
}

function* fetchData(action) {
    let getMOH = action.payload;
    let payload = {
        "apiName": "OrderBook",
        "body": {
            ...getMOH
        }
    };
    let apiresponse = yield call(fetchUser, payload)
    var investment = 0;
    var redemption = 0;
    var counterInvestment = 0;
    if (apiresponse.hasOwnProperty('code') && apiresponse.code === 401) {
        yield put({ type: type.ORDERBOOK_FAIL, Paylaod: "Logout", Data: { inprocess: [], investment: investment, redemption: redemption, counter: counterInvestment, holdingMode: null, processMode: null, transStatus: null } })
    } else {
        if (apiresponse?.data?.success) {
            let getRes = apiresponse?.data?.data?.data;
            let inprocessData = [];

            getRes.map((curr, index) => {
                if (curr.transtatus === "In Process") {
                    inprocessData.push(curr)
                    if (curr.buyOrSell === "Buy") {
                        if (curr.amount !== "") {
                            counterInvestment = counterInvestment + 1
                            investment = parseFloat(investment) + parseFloat(curr.amount)
                        }
                    }
                    if (curr.buyOrSell === "Sell" && curr.transTypeCategory === "Redemption") {
                        if (curr.amount !== "") {
                            redemption = parseFloat(redemption) + parseFloat(curr.amount);
                        }
                    }
                }
            })
            yield delay(100)
            let responseColl = collectHoldingMode(getRes);
            yield put({ type: type.ORDERBOOK_SUCCESS, Paylaod: getRes, Data: { inprocess: inprocessData, investment: investment, redemption: redemption, counter: counterInvestment, holdingMode: responseColl.holdingMode, processMode: responseColl.processMode, transStatus: responseColl.transStatus, transType: responseColl.transType } })

        } else {
            yield put({ type: type.ORDERBOOK_FAIL, Paylaod: [], Data: { inprocess: [], investment: investment, redemption: redemption, counter: counterInvestment, holdingMode: null, processMode: null, transStatus: null } })
        }
    }
}

export function* orderBookCall() {

    yield takeLatest(type.ORDERBOOK_PENDING, fetchData)
}

function collectHoldingMode(data) {
    let holdingMode = [];
    let processMode = [];
    let transStatus = [];
    let transType = ["ALL"];

    if (data.length > 0) {
        data.map((curr, ind) => {
            if (holdingMode.indexOf(curr.modeofHolding) === -1) {
                holdingMode.push(curr.modeofHolding);
            }
            if (processMode.indexOf(curr.channel) === -1) {
                processMode.push(curr.channel)
            }
            if (transStatus.indexOf(curr.transtatus) === -1) {
                transStatus.push(curr.transtatus)
            }
            if (transType.indexOf(curr.transTypeCategory) === -1) {
                transType.push(curr.transTypeCategory)
            }

        })
    }

    return { holdingMode: holdingMode, processMode: processMode, transStatus: transStatus, transType: transType };
}

